import { Box } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from 'common/components/Loader';
import { NotFound } from './ErrorPage';
import { RoutePath } from 'router/routes.paths';
import { useGetTournoiById } from 'features/tournois/tournoi.api';
import { getTournoiName } from 'features/tournois/tournoi.helper';
import { useMemo } from 'react';
import NouveauTournoiForm from 'features/tournois/components/NouveauTournoiForm';
import BPCPageHeading from 'common/components/BPCPageHeading';

export default function EditionTournoiPage() {
  const { id } = useParams<{ id: string }>();
  const { tournoi, isLoading } = useGetTournoiById(id!);
  const navigate = useNavigate();
  const tournoiName = useMemo(
    () => (tournoi ? getTournoiName(tournoi, 'short') : ''),
    [tournoi],
  );

  if (isLoading) {
    return <Loader fullScreen />;
  }

  if (!tournoi) {
    return <NotFound />;
  }

  return (
    <Box>
      <BPCPageHeading
        title={tournoiName}
        breadcrumbItems={[
          { to: RoutePath.home, name: 'Home' },
          { to: RoutePath.tournois, name: 'Tournois' },
          { to: `${RoutePath.tournois}/${id}`, name: tournoiName },
        ]}
      />
      <NouveauTournoiForm
        tournoi={{
          ...tournoi,
          championnatId: tournoi.championnatIds.length
            ? tournoi.championnatIds[0]
            : undefined,
        }}
        submitButtonLabel="Modifier le tournoi"
        onCancel={() => navigate(-1)}
      />
    </Box>
  );
}
